export enum LayoutDirection {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

// Single Report Display Config Start
interface Configuration {
  showAlertConfigValue: string;
  showRelatedLinksConfigValue: string;
  showTOCConfigValue: Array<string>;
}

export type SRConfigResponse = GlobalResponse<Configuration>;

// Single Report Display Config End

// Single Report  Start
interface ReportAnalysisOverviewPart2 {
  id: number;
  reportId: number;
  orgId: number;
  isAnalysis: boolean;
  isOverview: boolean;
}

interface ReportOverview {
  opinionOverviewId: number;
  colorkeyId: number;
  overview: string;
  reportId: number;
  comment: null;
  qualification: null;
}

export interface SupportDocumentTypeList {
  docTypeId: number;
  docTypeName: string;
}

export interface ReportAuthorAnalysis {
  analysisAuthor: string;
  localDateTime: null;
  reportId: number;
  orgId: number;
  showAnalysisDate: number;
  analysisDate: string;
}

interface ProductResponseDocument {
  docId: number;
  productId: number;
  fileName: string;
  stauts: number;
  extension: string;
}

interface Product {
  apiProductCode?: string | null;
  renderStyleId: number;
  renderStyleName: string;
  renderStyleSmallLogo: string;
  orgId: number;
  displayInSource: number;
  showHomePage: number;
  showPrimaryProduct: number;
  isDemonstration: number;
  isDiligence: number;
  isLargeBannerBlank: number;
  isSmallLogoBlank: number;
  renderStyleBenefit: string;
  renderStyleForOrgOnly: number;
  renderTypeId: number;
  status: number;
  htmlType: number;
  hideProduct: number;
  renderStyleDisclaimer: string;
  createdByUser: number;
  welcomeText: string;
  showComment: boolean;
  showAlert: number;
  showQuestionInCompare: number;
  showColorKey: number;
  allowGuests: number;
  saveAsOriginal: number;
  compareLimit: number;
  richTextOption: number;
  allowComparison: number;
  showCommentLink: number;
  showOnlyRelevantDefinition: number;
  showDefinitionsBottomPage: number;
  showExportToXml: number;
  removeNewUpdateFlagOfReports: number;
  showExportToExcelForReport: number;
  showExpandCollapseQuestionLink: number;
  showMoreLessLinkForOverviewText: number;
  titleOnly: number;
  showInDifferentColor: number;
  tooltipDescription: string;
  onlyAllowEditPart1: number;
  mandatoryEntity: number;
  showDefinitionsInTab: number;
  showInNavigation: number;
  questionWrapping: number;
  tabProQueSub: number;
  container: number;
  topAnswers: number;
  questionHeadings: number;
  mainAnswers: number;
  topQuestionHeading: number;
  reportHeader: number;
  isIntroductionText: number;
  isQuesInFilterView: number;
  isCompWithSecondReport: number;
  isGroupByRegions: number;
  isComparisonIntroductionText: number;
  showCommentForCompare: number;
  showJurisdictionNotAvailable: number;
  allowApi: number;
  showAllIdRef: number;
  jurisdictionLimitText: string;
  allowJurisdictionLimit: number;
  centralResetDate: string;
  applyBranding: number;
  navTabSubTab: number;
  searchQuestion: number;
  showExportToExcelForOpinionCompare: number;
  isIgnoreSubjectNode: number;
  paidSubscribeMsg: string;
  productIdRef: number;
  sfRenderStyleId: string;
  sfProductName: string;
  sfAosLoginId: string;
  sfProductId: string;
  sfProductFamily: string;
  sfCostTypeCode: string;
  enableAiSearch: number;
  showSubjectName: number;
  relatedLinkText: string;
  relatedToolText: string;
  showDocCategoriesDisplayedAsTabs: number;
}

interface FileTypeDetails {
  fileTypeId: number;
  extension: string;
  description: string;
  icon: string;
}

export interface ReportDetailsList {
  opinionId: number;
  opinionName: string;
  jurisdictionId: number;
  jurisdictionName: string;
  modifiedDate: string;
  orgId: number;
  opinionIDRef: string;
  createdByUserId: number;
  internalReviewStatusId: number;
  firstReviewerId: number;
  secondReviewerId: number;
  effectiveDate: string;
  apiVersionId?: number | null;
  apiVersionName?: string | null;
  // PRO only: linked PB/CR/EAM country manual + version saved from the edit page
  mappedCountryManualId?: number | null;
  mappedApiVersionId?: number | null;
  isShowFirstReviewerHomePage: number;
  saveAsOriginal: number;
  docId: number;
  docTypeId: number;
  docName: string;
  displayInSource: number;
  docDisplayOrder: number;
  fileTypeID: number;
  fileTypeDetails: FileTypeDetails;
  version: number;
  status: number;
  masterOpinionId: number;
  inProgressStatus: number;
  extension: string;
  lowerOpinionName: string;
  fileName: string;
  fileDir: string;
  fileSize: number;
  docTypeName: string;
  docAuthor: string;
  docAuthorUrl: string;
  isLink: number;
  link: string;
  isCore: number;
  icon: string;
  compare: number;
  showAuthor: number;
  showSourceInReport: number;
  hideDocuments: number;
  docTypeDisplayOrder: number;
  lastUpdatedOn: string;
}
export interface ReportOrganisationDetailListDetails {
  opinionId: number;
  opinionName: string;
  jurisdictionId: number;
  jurisdictionName: string;
  continentId: number;
  modifiedDate: string;
  renderStyleId: number;
  renderStyleName: string;
  categoryId: number;
  categoryType: string;
  categoryName: string;
  opinionIDRef: number;
  orgId: number;
  revDate: string;
  revDateAlert: string;
  regulatoryReviewDate: string;
  createdDate: string;
  createdByUserId: number;
  internalReviewStatusId: number;
  firstReviewerId: number;
  secondReviewerId: number;
  effectiveDate: string;
  internalReviewStatusTxt: string;
  isShowFirstReviewerHomePage: number;
  saveAsOriginal: number;
  access: string;
  docId: number;
  docTypeId: number;
  docName: string;
  docAuthor: string;
  displayInSource: boolean;
  docDisplayOrder: number;
  fileTypeID: number;
  fileTypeDetails: string;
  prodName: string;
  version: number;
  analysisName: string;
  analysisDate: string;
  continentName: string;
  agreementName: string;
  counterPartyName: string;
  opiniontagName: string;
  revDateAlertRecp: string;
  firstName: string;
  lastName: string;
  status: number;
  internalRef: string;
  notes: string;
  alternativeText: string;
  masterOpinionId: number;
  showPart4: number;
  policyComment: string;
  showNotificationInfo: number;
  colorCode: number;
  inProgressStatus: string;
  extension: string;
  lowerOpinionName: string;
  docDate: string;
  docAuthorUrl: string;
  docAddressee: string;
  fileName: string;
  fileDir: string;
  fileSize: string;
  docTypeName: string;
  isLink: boolean;
  link: string;
  isCore: boolean;
  icon: string;
  compare: boolean;
  showAuthor: boolean;
  showSourceInReport: boolean;
  hideDocuments: boolean;
  docTypeDisplayOrder: number;
  lastUpdatedOn: string;
  opinionOrgNotesId: number;
  showpart4: number;
}

interface FileTypeDetails {
  fileTypeId: number;
  extension: string;
  description: string;
  icon: string;
}

interface ReportAccess {
  orgId: number;
  createdByUserId: number;
  internalReviewStatusId: number;
  firstReviewerId: number;
  secondReviewerId: number;
  isShowFirstReviewerHomePage: number;
  saveAsOriginal: number;
  access: number;
  version: number;
  status: number;
}

export interface ISingleReport {
  reportAccess: ReportAccess | number;
  reportDetailsList: Array<ReportDetailsList>;
  reportOrganisationDetailList: Array<ReportOrganisationDetailListDetails>;
  product: Product;
  productResDoc: ProductResponseDocument;
  reportAuthorAnalysis: ReportAuthorAnalysis;
  supportDocTypeList: Array<SupportDocumentTypeList>;
  mainDocTypeList: Array<SupportDocumentTypeList>;
  reportOverview: ReportOverview;
  reportAnalysisOverviewPart2: ReportAnalysisOverviewPart2;
}

export type SingleReportResponse = GlobalResponse<ISingleReport>;

// Single Report End

// Single Report Opinion Content Tile Start
export interface IOpinionContentTile {
  opinionContentTileDetailsId: string;
  opinionId: number;
  opinionContentTileName: string;
  contentTileBehaviourTypeId: number;
  contentTileBehaviourTypeText: string;
  contentTileBehaviour: string;
  isDefault: number;
  displayOrder: number;
  parentId: number;
  status: number;
  isOnline: number;
  createdByUserId: number;
  createdDate: string;
  lastUpdatedByUserId: number;
  lastUpdatedDate: string;
  docName: null;
  fileName: null;
  originalFileName: null;
  fileTypeId: null;
  extension: string;
  icon: string;
  gridDisplayTypeId: number;
  gridDisplayType: string;
  gridFilterBy: string;
}
export type TOpinionContentTileList = Array<IOpinionContentTile>;

export type GetOpinionContentTileResponse =
  GlobalResponse<TOpinionContentTileList>;

// Single Report Opinion Content Tile End

// Single Report Related Alerts Start
export interface AlertsAfterSourceDate {
  alertId: number;
  summary: string;
  title: string;
  publicationDate: string;
  impact: number;
  status: null;
  lastSentDate: null;
  alwaysShowOnReport: number;
  imageName: string;
  imagePath: string;
  firstName: null;
  lastName: null;
  cnt: number;
  impactName: string;
  alertTagId: null;
  plainTitle: null;
}

interface OpinionAlertTagModelList {
  opinionId: number;
  alertTagId: null;
}

export interface AlertDetailWrapperModel {
  alertsAfterSourceDate: Array<AlertsAfterSourceDate>;
  alertsAlwaysShowOnReport: Array<AlertsAfterSourceDate>;
  alertsHideFromReport: Array<AlertsAfterSourceDate>;
}
export interface SRRelatedAlert {
  alertDetailWrapperModel: AlertDetailWrapperModel;
  opinionAlertTagModelList: Array<OpinionAlertTagModelList>;
}

export type GetSRReletedAlertResponse = GlobalResponse<SRRelatedAlert>;

// Single Report Related Alerts End

// Single Report Related Links Start

export interface ReportRelatedLink {
  renderStyleId: number;
  docId: number;
  fileName: string;
  status: number;
  extension: string;
  isLink: number;
  urlLink: string;
}

export type ReportRelatedLinkList = Array<ReportRelatedLink>;

export type GetReportRelatedLinkResponse =
  GlobalResponse<ReportRelatedLinkList>;

// Single Report Related Links End

// Single Report Overview config Start

export interface OverviewConfig {
  reportId: number;
  orgId: number;
  isAnalysis: number;
  isOverview: number;
}
export type GetReportOverviewConfigResponse = GlobalResponse<OverviewConfig>;

// Single Report Overview config End

// Single Report Get ORG by Product ID Start

export interface ApiRenderingStyleMapping {
  apiProductCode?: string | null;
  [key: string]: unknown;
}

export interface OrganisationDetail {
  renderStyleName: string;
  categoryId: number;
  categoryType: number;
  orgId: number;
  onlyAllowEditPart1: number;
  renderTypeId?: number;
  apiRenderingStyleMapping?: Array<ApiRenderingStyleMapping> | null;
}

export type GetOrganisationDetailResponse = GlobalResponse<OrganisationDetail>;
// Single Report Get ORG by Product ID End

// SIngle Report Get Color Options Start

export interface IColorOption {
  productId: number;
  productName: string;
  colorId: number;
  description: string;
  imagepath: string;
}

export type ColorOptionList = Array<IColorOption>;

export type GetColorOptionsResponse = GlobalResponse<ColorOptionList>;

export type GetLatestReportIdResponse = GlobalResponse<{ reportId: number }>;

// SIngle Report Get Color Options End

// Single Report Get Report Titles Start
export interface TemplateDetail {
  templateId: number;
  templateName: string;
  displayOrder: number;
}

export type TemplateDetailList = Array<TemplateDetail>;

export type GetReportTemplatesResponse = GlobalResponse<TemplateDetailList>;

export interface ReportQuestion {
  questionId: number;
  questionTitle: string;
  questionDescription: null | string;
  questionComment: null;
  displayOrder: number;
  templateId: number;
  subjectId: number;
  subjectName: string;
  isTreeTypeId: number;
  isTreeType: number;
  idRef: null;
  refQuelIDRef: null;
  edocId: null;
  epage: null;
  isDivider: null;
  count: null;
  questionCounter: null;
  rowId: null;
  selected: boolean;
  titleResponseType: null;
  xmlString: null;
  templateOpinionOrgId: null;
  opinionId: null;
  orgId: null;
  opinionTempQuesOrgId: null;
}

export type getReportQuestionResponse = GlobalResponse<Array<ReportQuestion>>;
// Single Report Get Report Titles End

// Single Report Get Questions and Answer Start
interface QuestionRef {
  questionId: number;
  questionTitle: null;
  questionDescription: null;
  questionComment: null;
  displayOrder: null;
  templateId: null;
  subjectId: null;
  subjectName: null;
  isTreeTypeId: null;
  isTreeType: null;
  idRef: string;
  edocId: null;
  epage: null;
  isDivider: null;
}

interface QuestionResponseTypeModelForDividerQuestion {
  isDivider: number;
  responseTypeId: number;
  responseTypeName: null;
  questionId: number;
  templateId: number;
  isDividerQuestionModelId: null;
  orderId: null;
}

interface QuestionResponseTypeModelForSubDividerQuestion {
  isDivider: number;
  responseTypeId: number;
  responseTypeName: null;
  questionId: number;
  templateId: number;
  isDividerQuestionModelId: null;
  orderId: null;
  questionResponseTypeId: null;
}
export interface CpCheckQuestion {
  questionId: number;
  reportId: number;
  templateId: number;
  counterPartyId: number | null;
  counterPartyName: string;
  subNodeTitle: string;
  subNodeTitleId: number;
  displayOrder: number;
  transactionID: number | null;
}

export interface DocumentQuestionReference {
  opinionId: number;
  templateId: number;
  questionId: number;
  orgId: number;
  referenceText: string;
}

export interface QuestionResourceDocument {
  questionId: number;
  docId: number;
  fileDir: string;
  extension: string;
  pageReferenceNo: number;
  productId: null;
}

interface QuesSubAnswerResponseType {
  questionId: number;
  subAnswerResponseTypeId: number;
  subAnswerResponseName: string;
}

export interface ResponseTypeBlockList {
  responseRowId: number;
  opinionId: number;
  templateId: number;
  questionId: number;
  orgId: number;
  blockId: number;
  subblockId: number;
  subNodeTitleId: number;
  setHazardColorPicker: number;
  setHazardText: null;
  setColorOption: number;
  setFactPattern: number;
  setAnswer: number;
  setAnswerOther: string;
  setComments: string;
  setQualifications: string;
  setHeading: string;
  setResponseBox: string;
  setCustomTextBoxTitle: string;
  setCustomTextBox: string;
  setCustomeDate: string;
  setCustomeDateText: string;
  setCreatedDate: string;
  setDocumentName: string;
  setFilename: string;
  setFileDir: string;
  setFilesize: number;
  setFileExt: string;
  setFileExtId: number;
  setDocId: number;
  setSupportDocumentName: string;
  setSupportFileDir: string;
  setSupportFilesize: number;
  setSupportCreatedDate: string;
  setSupportFileExt: string;
  setSupportFileExtId: number;
  setSupportDocId: number;
  setSupportDocType: number;
  setSupportDocDate: string;
  setSupportAuthName: string;
  setSupportAddrName: string;
  setSupportFileName: string;
  setCounterPartyEntityName: string;
  setLeftColumnText: string;
  setRightColumnText: string;
  setUrl: string;
  setUrlTitle: string;
  responseDisplayOrder?: number;
  addBlock?: boolean;
}

export interface Question {
  questionId: number;
  questionTitle: string;
  questionDescription: string;
  questionComment: null;
  displayOrder: number;
  templateId: number;
  subjectId: number;
  subjectName: string;
  isTreeTypeId: number;
  isTreeType: number;
  idRef: null;
  edocId: string;
  epage: string;
  isDivider: null;
}

export interface ExpandableCommentsItem {
  blockId: number;
  subBlockId: number;
  responseId: number;
  heading: string;
  expandableCommentText: string;
  displayOrder: number;
  reportId: number;
}

export type ExpandableCommentsItemList = Array<ExpandableCommentsItem>;

export type CpCheckQuestionList = Array<CpCheckQuestion>;
interface AnswerResponseModel {
  responseTypeBlockList: Array<ResponseTypeBlockList>;
  twoColumnOnModel: null;
  quesSubAnswerResponseTypes: Array<QuesSubAnswerResponseType>;
  questionResourceDoc: QuestionResourceDocument;
  docQuestionReferences: Array<DocumentQuestionReference>;
  cpCheckQuestions: CpCheckQuestionList;
  expandableComments: ExpandableCommentsItemList;
}

interface FormattingModal {
  questionId: number;
  lineBelow: boolean;
  noLine: boolean;
  lineAbove: boolean;
  bold: boolean;
}

export interface  QuestionAndAnswerList {
  question: Question;
  answerResponseModel: AnswerResponseModel;
  questionResponseTypeModelForDividerQuestions: Array<QuestionResponseTypeModelForDividerQuestion>;
  allDividerQuestionResponseTypeModels: Array<QuestionResponseTypeModelForDividerQuestion>;
  questionResponseTypeModelForSubDividerQuestions: Array<QuestionResponseTypeModelForSubDividerQuestion>;
  allSubDividerQuestionResponseTypeModels: Array<QuestionResponseTypeModelForSubDividerQuestion>;
  questionFormattingModel: FormattingModal;
  questionRef: QuestionRef;
}

export type GetQuestionAndAnswerListResponse = GlobalResponse<
  Array<QuestionAndAnswerList>
>;

// Single Report Get Questions and Answer End

// Single Report  Response Type Start
interface ReportResponseType {
  responseTypeId: number;
  responseTypeName: string;
  responseTypeNameSys: string;
  orderId: number;
}

export type ReportResponseTypeList = Array<ReportResponseType>;

export type GetReportResponseTypeListResponse =
  GlobalResponse<ReportResponseTypeList>;

// Single Report Response Type End

// Single Report Answer Response Type Start
interface ReportAnswerResponseType {
  isDivider: null;
  responseTypeId: number;
  responseTypeName: string;
  questionId: number;
  templateId: null;
  isDividerQuestionModelId: null;
  orderId: number;
}

export type RportAnswerResponseTypeList = Array<ReportAnswerResponseType>;

export type GetRportAnswerResponseTypeListResponse =
  GlobalResponse<RportAnswerResponseTypeList>;

export type ReportAnswerResponseTypeIdsByQuestionId = Record<
  string,
  Array<number>
>;

export type GetReportAnswerResponseTypesBatchResponse =
  GlobalResponse<ReportAnswerResponseTypeIdsByQuestionId>;

// Single Report Answer Response Type End

// Single Report Tree Type Start
interface TreeType {
  treeTypeId: number;
  treeTypeName: string;
}

type TreeTypeList = Array<TreeType>;

export type GetTreeTypeResponse = GlobalResponse<TreeTypeList>;

// Single Report Tree Type END

// Single Report Fact Pattern Start
export interface FactPattern {
  productId: number;
  productName: string;
  colorId: number;
  description: string;
  imagepath: string;
  factID: number;
  factId?:number
}

export type FactPatternList = Array<FactPattern>;

export type FactPatternListResponse = GlobalResponse<FactPatternList>;
// Single Report Fact Pattern End

// Single Report Grayout Response Start\
interface GrayOut {
  responseGreyOutId: number;
  questionId: number;
  orgId: number;
  reportId: number;
  templateId: number;
  blockId: number;
  subBlockId: number;
}

export type GrayOutList = Array<GrayOut>;

export type GrayOutListResponse = GlobalResponse<GrayOutList>;
// Single Report Grayout Response End

export type FileTypeDetailsApiItem = {
  fileTypeId: number;
  extension: string;
  description: string;
  icon: string;
};

export type FileTypeDetailsApiResponse = GlobalResponse<Array<FileTypeDetailsApiItem>>;

// Single Report Decrypt Eurl Start
export interface DecryptData {
  opinionId?: string;
  preview: string;
  JuriID: string;
  opinionID: string;
  ProdName: string;
  keyvalue: string;
  templateList: string;
  JuriName: string;
  ProdID: string;
  pagetype?: string;
  catId?: string;
  OpinionEditTypeValue?: string;
  caller?: string;
  getRenderingStyle?: string;
  isRelatedTool?: string;
  review?: string;
  catType?: string;
  first?: string;
  catID?: string;
  Jurisdiction?: string;
  source?: string;
  search?: string;
  orderby?: string;
  compare?: number;
  status?: string;
  pageId?: string;
  gridId?: string;
  gridID?: string;
  /** When set, grid entry should decrypt this token next (chain) before using gridId etc. */
  eurl?: string;
  eUrl?: string;
  eURL?: string;
  fromPage?: string;
  pageID?: string;
  renderStyle?:string;
  colIds?:string;
  rowIds?:string;
  isShareLink?: string;
  gridDisplayTypeId?: number;
  opinionContentTileName?: string;
  contentTileDetailsId?: string;
  selectedTemplateId?: string;
  tabtemplateID?: string;
  tabTemplateID?: string;
  /** When present in share URL, the tab-type report opens with this sub-tab (subject) selected */
  selectedSubjectId?: string;
  tabSubjectID?: string;
  tabsubjectID?: string;
  categoryId?: string;
  categoryType?: string;
  days?: string;
  showSuccessMsg?: string;
}

export type DecryptDataResponse = GlobalResponse<DecryptData>;
// Single Report Decrypt Eurl End

// Single Report Product API Access Start
interface ProductAccess {
  id: null;
  isOrgProd: null;
  renderStyleId: number;
  renName: null;
  renderStyleName: null;
  categoryId: null;
  categoryType: null;
  orgId: null;
  orgName: null;
  categoryName: null;
  showHomePage: null;
  showPrimaryProduct: null;
  isDemonstration: null;
  isDiligence: null;
  isLargeBannerBlank: null;
  isSmallLogoBlank: null;
  renderStyleBenefit: null;
  renderStyleForOrgOnly: null;
  renderTypeId: null;
  status: null;
  htmlText: null;
  htmlType: null;
  hideProduct: null;
  renderStyleDisclaimer: null;
  createdByUser: null;
  welcomeText: null;
  showComment: null;
  showAlert: null;
  showQuestionInCompare: null;
  showColorKey: null;
  allowGuests: null;
  saveAsOriginal: null;
  compareLimit: null;
  richTextOption: null;
  allowComparison: null;
  showCommentLink: null;
  showOnlyRelevantDefinition: null;
  showDefinitionsBottomPage: null;
  showExportToXml: null;
  showExportToExlOpCmpr: null;
  showDefinitionsIntegerab: null;
  removeNewUpdateFlagOfReports: null;
  showExportToExcelForReport: null;
  showExpandCollapseQuestionLink: null;
  showMoreLessLinkForOverviewText: null;
  titleOnly: null;
  showInDifferentColor: null;
  tooltipDescription: null;
  count: null;
  onlyAllowEditPart1: number;
  gridId: null;
  mandatoryEntity: null;
  showDefinitionsInTab: null;
  showInNavigation: null;
  questionWrapping: null;
  tabProQueSub: null;
  container: null;
  topAnswers: null;
  questionHeadings: null;
  mainAnswers: null;
  topQuestionHeading: null;
  reportHeader: null;
  isIntroductionText: null;
  introductionText: null;
  isQuesInFilterView: null;
  isIgnoreSujectNode: null;
  isCompWithSecondReport: null;
  isGroupByRegions: null;
  isComparisonIntroductionText: null;
  comparisonIntroductionText: null;
  showCommentForCompare: null;
  showJurisdictionNotAvailable: null;
  paidSubscibeMsg: null;
  productIdRef: null;
  allowApi: number;
  showAllIdRef: number;
  jurisdictionLimitText: null;
  allowJurisdictionLimit: null;
  centralResetDate: null;
  applyBranding: null;
  navTabSubTab: null;
  searchQuestion: null;
  renderStyleLargeBanner: null;
  renderStyleSmallLogo: null;
  showExportToExcelForOpinionCompare: null;
  isIgnoreSubjectNode: null;
  paidSubscribeMsg: null;
  sfRenderStyleId: null;
  sfProductName: null;
  sfAosLoginId: null;
  sfProductId: null;
  sfProductFamily: null;
  sfCostTypeCode: null;
  enableAiSearch: null;
  showSubjectName: null;
  relatedLinkText: null;
  relatedToolText: null;
  docId: null;
  fileName: null;
  extension: null;
  isLink: null;
  urlLink: null;
  reportId: null;
  alertId: null;
  factPatternId: null;
  description: null;
  imagePath: null;
}

export type ProductAccessList = Array<ProductAccess>;

export type ProductAccessListResponse = GlobalResponse<ProductAccessList>;
// Single Report Product API Access End

// Single Report Question Exist in template Start
interface QuestionExistTemplate {
  opinionTempQuesOrgId: number;
  questionId: number;
  templateOpinionOrgId: number;
  questionCounter: number;
  counterPartyId: number | null;
  counterPartyName: string | null;
  subNodeTitle: string | null;
  subNodeTitleId: number | null;
  displayOrder: number | null;
}

export type QuestionExistTemplateResponse = GlobalResponse<
  Array<QuestionExistTemplate>
>;
// Single Report Question Exist in template end

// single report comments start
interface AlertImpact {
  alertImpactId: number;
  name: string;
  imagePath: string;
  description: string;
  alternateText: null;
  reportAltText: null;
}

interface Comment {
  opinionCommentId: number;
  opinionId: number;
  comment: string;
  displayComment: number;
  triggerAlert: number;
  commentFlag: number;
  status: number;
  impact: number;
  version: number;
  alertImpact: AlertImpact;
}

export type SRCommentList = Array<Comment>;

export type GetSRCommentResponse = GlobalResponse<SRCommentList>;
// Single report comments end

// Single report window data start
export interface CounterPartyModel {
  count: null;
  counterPartyId: null;
  counterPartyName: string;
  opinionId: number;
  templateId: number;
  questionId: number;
  questionTitle: null;
  displayOrder: number;
  questionDescription: null;
  subjectName: null;
  isDivider: null;
  subNodeTitle: null;
  subNodeTitleId: null;
}

export interface AgreementModel {
  count: null;
  agreementId: number;
  agreementName: string;
  opinionId: number;
}

export interface AnalysisModel {
  count: number;
  analysisId: number;
  analysisName: string;
  opinionId: number;
}

export interface DocumentAuthorModel {
  docAuthor: string;
  docId: number;
  docAddressee?: string | null;
  opinionId: number;
}

interface OpinionTagModel {
  opinionTagId: number;
  opinionTagName: string;
}

export interface JurisdictionModel {
  jurisdictionId: number;
  jurisdictionName: string;
  opinionId: number;
  modifiedDate: string;
  version: number;
}

export interface OpinionModel {
  opinionId: number;
  opinionName: string;
  jurisdictionId: number;
  jurisdictionName: string;
  continentId: number;
  modifiedDate: string;
  renderStyleId: number;
  renderStyleName: string;
  categoryId: number;
  categoryType: string;
  categoryName: string;
  opinionIDRef: string;
  orgId: number;
  revDate: string;
  revDateAlert: string;
  regulatoryReviewDate: string;
  createdDate: string;
  createdByUserId: number;
  internalReviewStatusId: number;
  firstReviewerId: number;
  secondReviewerId: number;
  effectiveDate: string;
  internalReviewStatusTxt: string;
  isShowFirstReviewerHomePage: number;
  saveAsOriginal: number;
  access: any;
  docId: any;
  docTypeId: any;
  docName: string;
  docAuthor: string;
  displayInSource: number;
  docDisplayOrder: any;
  fileTypeID: any;
  fileTypeDetails: any;
  prodName: string;
  version: number;
  analysisName: string;
  analysisDate: string;
  continentName: string;
  agreementName: string;
  counterPartyName: string;
  opiniontagName: string;
  revDateAlertRecp: string;
  firstName: string;
  lastName: string;
  status: number;
  internalRef: string;
  notes: string;
  alternativeText: string;
  masterOpinionId: number;
  showPart4: any;
  policyComment: string;
  showNotificationInfo: any;
  colorCode: string;
  inProgressStatus: number;
  extension: string;
  lowerOpinionName: string;
  docDate: string;
  docAuthorUrl: string;
  docAddressee: string;
  fileName: string;
  fileDir: string;
  fileSize: string;
  docTypeName: string;
  isLink: boolean;
  link: string;
  isCore: boolean;
  icon: string;
  compare: boolean;
  showAuthor: boolean;
  showSourceInReport: boolean;
  hideDocuments: boolean;
  docTypeDisplayOrder: number;
  lastUpdatedOn: string;
  opinionOrgNotesId: number;
}

export interface MasterOpinionModel {
  opinionId: number;
  opinionName: string;
  jurisdictionId: null;
  jurisdictionName: null;
  continentId: null;
  modifiedDate: null;
  renderStyleId: null;
  renderStyleName: null;
  categoryId: null;
  categoryType: null;
  categoryName: null;
  opinionIDRef: null;
  orgId: number;
  revDate: null;
  revDateAlert: null;
  regulatoryReviewDate: null;
  createdDate: string;
  createdByUserId: number;
  internalReviewStatusId: number;
  firstReviewerId: number;
  secondReviewerId: number;
  effectiveDate: null;
  internalReviewStatusTxt: null;
  isShowFirstReviewerHomePage: number;
  saveAsOriginal: number;
  access: null;
  docId: null;
  docTypeId: null;
  docName: null;
  docAuthor: null;
  displayInSource: null;
  docDisplayOrder: null;
  fileTypeID: null;
  fileTypeDetails: null;
  prodName: null;
  version: number;
  analysisName: null;
  analysisDate: null;
  continentName: null;
  agreementName: null;
  counterPartyName: null;
  opiniontagName: null;
  revDateAlertRecp: null;
  firstName: string;
  lastName: string;
  status: number;
  internalRef: null;
  notes: null;
  alternativeText: null;
  masterOpinionId: number;
  showPart4: null;
  policyComment: null;
  showNotificationInfo: null;
  colorCode: null;
  inProgressStatus: null;
  extension: null;
  lowerOpinionName: null;
  docDate: null;
  docAuthorUrl: null;
  docAddressee: null;
  fileName: null;
  fileDir: null;
  fileSize: null;
  docTypeName: null;
  isLink: null;
  link: null;
  isCore: null;
  icon: null;
  compare: null;
  showAuthor: null;
  showSourceInReport: null;
  hideDocuments: null;
  docTypeDisplayOrder: null;
  lastUpdatedOn: null;
  opinionOrgNotesId: null;
}

export interface ProductModel {
  renderStyleId: number;
  renderStyleName: string;
  opinionId: number;
}

export interface OrganisationModel {
  orgId: null;
  orgTypeId: null;
  orgName: null;
  orgEntityId: null;
  orgEntityName: null;
  notes: null;
  contactFirstName: null;
  contactLastName: null;
  contactAddress1: null;
  contactAddress2: null;
  contactCountry: null;
  contactZip: null;
  contactPhone: null;
  contactMobile: null;
  contactFax: null;
  contactEmail: null;
  hasBanner: null;
  createdDate: null;
  modifiedDate: string;
  status: null;
  addNotes: null;
  relatedAppDomain: null;
  isAnonymised: null;
  addNotesDaysAfterPublication: null;
  addNotesDaysForReminder: null;
  addNotesDaysForReminderForClientProduct: null;
  pwdExpiryDays: null;
  orgCategoryId: null;
  createdByVendorId: null;
  sfOrganisationId: null;
  sfOrganisationName: null;
  enableLoginOtpAdmin: null;
  enableLoginOtpEdit: null;
  enableLoginOtpView: null;
  enableV2Captcha: null;
  opinionId: number;
  regulatoryReviewDate: string;
  revDate: string;
  policyComment: string;
  docExpDateAlert: string;
  revDateAlertRecp: string;
  revDateAlert: string;
  colorCode: number;
  showPart4: number;
  showNotificationInfo: number;
  internalReviewStatusID: number;
  firstReviewerId: number;
  secondReviewerId: number;
  internalReviewStatusTxt: string;
  effectiveDate: string;
}
export type masterReportIds= Array<number>;
export interface ReportWindowData {
  counterPartyModels?: Array<CounterPartyModel>;
  agreementModels?: Array<AgreementModel>;
  analysisModels?: Array<AnalysisModel>;
  docAuthorModels?: Array<DocumentAuthorModel>;
  opinionTagModels?: Array<OpinionTagModel>;
  jurisdictionModels?: Array<JurisdictionModel>;
  opinionModels?: Array<OpinionModel>;
  masterOpinionModels?: Array<MasterOpinionModel>;
  masterReportIds?: masterReportIds;
  productModels?: Array<ProductModel>;
  organisationModels?: Array<OrganisationModel>;
}

export interface ReportWindowResponse {
  message: string;
  data: ReportWindowData;
}

// Single report window data end
export interface ReportVersion {
  currentVersion: number;
  currentOpinionId: number;
}
export type ReportVersionResponseData = GlobalResponse<Array<ReportVersion>>;
export interface ReportNoteContact {
  addNotesContactsId: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  phone: string;
  opinionId: number;
}

export type ReportNoteContactsResponse = GlobalResponse<
  Array<ReportNoteContact>
>;

export interface ReportNoteGuidance {
  addNotesGuidanceId: number;
  colorCode: number;
  category: string;
  comment: string;
  answer: string;
  opinionId: string;
  orgId: string;
}

export type ReportNoteGuidanceResponse = GlobalResponse<
  Array<ReportNoteGuidance>
>;
export interface ReportNoteResource {
  addNotesResourcesId: number;
  opinionId: number;
  orgId: number;
  comment: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  phone: string;
}

export type ReportNoteResourcesResponse = GlobalResponse<
  Array<ReportNoteResource>
>;

export interface GuidanceAttachment {
  addNotesGuidanceAttachmentId: number;
  addNotesGuidanceId: number;
  isLink: number;
  docId: string;
  title: string;
  docFileSize: number;
  docFileExt: string;
  originalFileName: string;
  linkUrl: string;
  opinionId?: number;
}
export type ReportNoteGuidanceAttachmentResponse = GlobalResponse<
  Array<GuidanceAttachment>
>;

export type ReportAttachment = {
  attachmentId: number;
  resourceId: number;
  isLink: number;
  docId: number;
  title: string;
  docFileSize: number;
  docFileExt: string;
  originalFileName: string | null;
  linkUrl: string | null | undefined;
  reportId?: number;
};
export type ReportNotesResourcesResponse = {
  message: string;
  data: Array<ReportAttachment>;
};

interface OpinionAccessData {
  checkReportAccesscnt1: number;
  reportCoOrdinatingFirmEditAccess: number;
  checkIsGuestUser: number;
}

export type OpinionAccessResponse = {
  message: string;
  data: OpinionAccessData;
};

interface ExportExcelInOpinionViewUserResponseModelList {
  exportExcelInOpinionViewUserId: number;
  userId: number;
  productId: number;
}

interface ExportExcelInOpinionViewOrgResponseModelList {
  exportExcelInOpinionViewUserId: number;
  orgId: number;
  productId: number;
}

interface ExportToExcelViewData {
  exportExcelInOpinionViewOrgResponseModelList: Array<ExportExcelInOpinionViewOrgResponseModelList>;
  exportExcelInOpinionViewUserResponseModelList: Array<ExportExcelInOpinionViewUserResponseModelList>;
}

export interface ExportToExcelViewResponse {
  message: string;
  data: ExportToExcelViewData;
}

interface GridExportExcelOrgResponseModel {
  gridExportExcelOrgId: number;
  renderingStyleId: number;
  orgId: number;
}

interface GridExportExcelUserResponseModel {
  gridExportExcelUserId: number;
  userId: number;
  renderingStyleId: number;
}

interface GridExportToExcelAccessData {
  gridExportOrgResponseModelList: Array<GridExportExcelOrgResponseModel>;
  gridExportUserResponseModelList: Array<GridExportExcelUserResponseModel>;
}

export interface GridExportToExcelAccessResponse {
  message: string;
  data: GridExportToExcelAccessData;
}

interface GridExportPDFOrgResponseModel {
  gridExportPDFOrgId: number;
  renderingStyleId: number;
  orgId: number;
}

interface GridExportPDFUserResponseModel {
  gridExportPDFUserId: number;
  userId: number;
  renderingStyleId: number;
}

interface GridExportToPdfAccessData {
  gridExportOrgResponseModelList: Array<GridExportPDFOrgResponseModel>;
  gridExportUserResponseModelList: Array<GridExportPDFUserResponseModel>;
}

export interface GridExportToPdfAccessResponse {
  message: string;
  data: GridExportToPdfAccessData;
}

export interface ExportToXMLResponse {
  message: string;
  data: number;
}


export interface FileDownloadType {
  docId: number;
  extension: string;
  fileDir: string;
  filename:string;
  opinionID:number;
  opinionCompare:number;
  message:string;
}

export interface ViewDocumentMutationParameters {
  filename: string;
  path?: string;
  type?: string;
  compare?: number;
  location?: string;
  renStyleID?: number;
  prodID?: number;
  isMtob?: number;
}

export interface CategoryDetailsByOpinionIdData {
  opinionId: null;
  opinionName: string;
  categoryId: number;
  categoryName: string;
  categoryType: number;
  renderStyleId: number;
  renderStyleName: string;
  renderTypeId: null;
  renderingTypeId: null;
  renderingTypeName: null;
  effectiveDate: null;
  verPublishDate: null;
  commentFlag: null;
  showCommentFlag: null;
  commentFlagName: null;
  orgId: null;
  opinionStatus: null;
  masterOpinionId: null;
  defaultFilterView: null;
  modifiedDate: null;
  createdDate: null;
  saveAsOriginal: null;
  jurisdictionId: null;
  bookmarkId: null;
  removeNewUpdateFlagOfReports: null;
  inProgressStatus: null;
  mandatoryEntity: null;
  usedJurisdiction: boolean;
  versionDisabled: boolean;
  allowGuests: null;
  status: number;
  statusName: null;
  opinionIdRef: null;
  createdBy: null;
  modifiedBy: null;
  continentName: null;
  version: null;
  internalRef: null;
  notes: null;
  masterStatus: null;
  alternativeText: null;
  lastUpdatedOn: null;
  oldLastUpdatedOn: null;
  reportComment: null;
  compare: null;
  showSourceInReport: null;
  hideDocuments: null;
  opinionVersions: null;
  jurisdictionName: null;
  continentId: null;
  firstName1: null;
  lastName1: null;
  firstName2: null;
  lastName2: null;
  internalReviewStatusTxt: null;
  revDate: null;
  regulatoryReviewDate: null;
  analysisDate: null;
  analysisAuthor: null;
  showAnalysisDate: null;
  fromDate: null;
  toDate: null;
  days: null;
  internalReviewStatus: null;
  demonstration: null;
  region: null;
  renderStyleIds: null;
  jurisdictionIds: null;
  reviewerId: null;
  userId: null;
  firstName: null;
  lastName: null;
}

export interface CategoryDetailsByOpinionIdResponse {
  message: string;
  data: CategoryDetailsByOpinionIdData;
}

export interface GenerateReportPDFRequest {
  eUrl: string;
}

export interface GenerateTabReportPDFRequest {
  reportId: number;
  factPatternIds: Array<number>;
  renId: number;
  chkComment: number;
  keyValueInfo: string;
  templateIds: string | number;
  questionIds: string | number;
  downloadFile?: number;
}

export interface GenerateTabReportExcelRequest {
  reportId: number;
  showBackInfo?: number;
  showComment?: number;
  keyValue: string;
  templateIds?: string;
  questionIds?: string;
  factPatternIds?: string;
  renderingStyleId?: string | number;
}

interface Reference {
  opinionOrgNotesId: number;
  reportId: number;
  orgId: number;
  notes: string;
  internalRef: string;
}

export type ReferenceList = Array<Reference>;

export type InternalReferenceResponse = GlobalResponse<ReferenceList>


export interface leftResponse {
  leftColumnText: string;
  rightColumnText: string;
  headingText: string;
  hazardText: string;
  hazardIcon: string;
  colorOption: string;
  factPattern: string;
  counterpartyEntityNameText: string;
  subAnswerResponseNameText: string;
  otherAnswerText: string;
  qualificationText: string;
  commentText: string;
  customDateText: string;
  customDate: string;
  responseBoxText: string;
  customTextBoxTitleText: string;
  customTextBoxText: string;
  documentIcon: string;
  documentIconExtId: string;
  documentNameText: string;
  supportDocumentIcon: string;
  supportDocumentNameText: string;
  supportDocTypeText: string;
  supportDocDate: string;
  supportDocDateText: string;
  supportAuthNameText: string;
  url: string;
  urlTitle: string;
}


export interface GetRegionDataByJuriIdResponseData {
  continentId: number;
  continentName: string;
  mapCoOrdinates: string;
  mapShape: string;
  svgContinent: string;
}
export type GetRegionDataByJuriIdResponse = GlobalResponse<GetRegionDataByJuriIdResponseData>

interface ExportReportExcel {
  prefix: string;
  fileName: string;
}

export type ExportReportExcelResponse = GlobalResponse<ExportReportExcel>

export interface ReportNodesDetailsResponse {
  message?: string;
  data?: Array<number> | null;
}

export interface ReportFileByApi {
  id: string;
  reportId: number;
  docTypeId: number;
  docTypeName: string;
  displayInSource: boolean;
  fileByApiEnum: string;
  fileByApiDisplayName: string;
  displayOrder: number;
}

export type ReportFileByApiList = Array<ReportFileByApi>;

export type GetReportFileByApiResponse = GlobalResponse<ReportFileByApiList>;